import React, { useEffect, useRef, useState } from "react";
import CommonService from "../../services/common.service";
import { Link } from "react-router-dom";
import usePaginatedData from "../../hooks/usePaginatedData";
import PlayerCardModal from "../Player/PlayerCardModal";
import GamePassModal from "../GamePassModal";
import { isUserPaid } from "../../utils/userPremiumUtils";
import DownloadPlayerCard from "../Player/DownloadPlayerCard";
import { Button } from "react-bootstrap";

const PlayersCard = () => {
  const userPaidForClub = isUserPaid();
  const club_details = JSON.parse(localStorage.getItem("club_details"));
  const [isActive, setActive] = useState(false); // Toggle state.
  const [searchTerm, setSearchTerm] = useState(""); // Search term state.
  const [sortState, setSortState] = useState({
    sortBy: null,
    order: null,
  }); // Sorting state.

  const apiUrl = "playerListCard"; // Backend API endpoint.
  const {
    data: playerList,
    currentPage,
    totalPages,
    loading,
    error,
    handleSearch,
    handleSort,
    handlePageChange,
  } = usePaginatedData(apiUrl, { limit: 200 }); // Custom hook.

  // Toggle Functionality
  const handleToggle = () => {
    setActive(!isActive);
  };

  // Debounced Keyword Search
  let debounceTimer;
  const handleKeywordChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Clear existing debounce timer.
    clearTimeout(debounceTimer);

    // Set a new debounce timer for search.
    debounceTimer = setTimeout(() => {
      handleSearch("keyword", value); // Pass `keyword` to backend for searching multiple fields.
    }, 300); // Adjust debounce delay as needed.
  };

  // Sorting by Column
  const handleColumnSort = (column) => {
    const isAscending =
      sortState.sortBy === column && sortState.order === "ASC";
    const newOrder = isAscending ? "DESC" : "ASC";

    setSortState({ sortBy: column, order: newOrder });
    handleSort(column, newOrder); // Pass column and order to backend for sorting.
  };

  const handleResetSearch = () => {
    setSearchTerm(""); // Clear the search term state.
    handleSearch("keyword", ""); // Trigger search with an empty keyword to fetch all records.
  };

  const [playerCardShow, setPlayerCardShow] = useState(false);
  const [playerCardDownloadShow, setPlayerCardDownloadShow] = useState(false);
  const [pass, setPass] = useState(false);
  const [playerCardData, setPlayerCardData] = useState({});
  const [playerTeamName, setPlayerTeamName] = useState();
  const [playerGameName, setPlayerGameName] = useState();
  const [playerSponsor, setPlayerSponsor] = useState({});

  const handleClose = () => setPlayerCardShow(false);
  const handlePlayerDownloadCardClose = () => setPlayerCardDownloadShow(false);
  const handlePlayerCardShow = () => setPlayerCardShow(true);
  const [playerCardModalData, setPlayerCardModalData] = useState({});
  const [playerSelected, setPlayerSelected] = useState();
  const [playerProfileView, setPlayerProfileView] = useState(0);

  const [showGamePass, setShowGamePass] = useState(false);
  const handleCloseGamePass = () => setShowGamePass(false);
  const handleGamePassModalShow = () => {
    setShowGamePass(true);
  };

  const playerCardHandle = (item) => {
    setPlayerCardShow(true);
    setPlayerCardData(item);
    setPlayerSponsor(item["player_sponsor"]);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData({
          ...res.data,
          ...res.playerCardModalData,
        });

        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setPlayerSelected(res.player_count);
        setPlayerProfileView(res.playerProfileViews);
      }
    });
  };

  const handleDownloadClick = (item) => {
    setPlayerCardDownloadShow(true);
    setPlayerCardData(item);
    setPlayerSponsor(item["player_sponsor"]);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData({
          ...res.data,
          ...res.playerCardModalData,
        });

        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setPlayerSelected(res.player_count);
        setPlayerProfileView(res.playerProfileViews);
      }
    });
  };
  return (
    <>
      <div className="searchfilter">
        <div
          className={isActive ? "custom-searchbox open" : "custom-searchbox"}
        >
          <Link to="" className="searchicon" onClick={handleToggle}>
            <img src="images/search-icon.png" alt="img" />
          </Link>
          <div className="searchbox">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleKeywordChange}
            />
            <Link href="" className="closeicon">
              <img
                src="images/close-icon-blue.png"
                alt="img"
                onClick={handleResetSearch}
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="customscroll rankcustomscroll mb-2">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th
                style={{ cursor: "pointer" }}
                onClick={() => handleColumnSort("full_name")}
              >
                Player
                {sortState.sortBy === "full_name" &&
                  (sortState.order === "ASC" ? " ↑" : " ↓")}
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {playerList.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className="playerinfo">
                    <div className="playerimg">
                      <figure>
                        {item?.is_avatar === 1 ? (
                          <img
                            src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`}
                            alt="img"
                          />
                        ) : (
                          <img
                            src={`${process.env.REACT_APP_UPLOAD_URL}player/${item.image}`}
                            alt="img"
                          />
                        )}
                      </figure>
                    </div>

                    <h5>
                      {" "}
                      <Link onClick={() => playerCardHandle(item)}>
                        {" "}
                        {item.full_name}
                      </Link>{" "}
                    </h5>
                  </div>
                </td>
                <td>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownloadClick(item)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PlayerCardModal
        show={playerCardShow}
        handleClose={handleClose}
        handleShow={handlePlayerCardShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
        playerSelected={playerSelected}
        playerProfileView={playerProfileView}
        handleGamePassModalShow={handleGamePassModalShow}
        userPaidForClub={userPaidForClub}
        playerSponsor={playerSponsor}
        club_details={club_details}
      />
      <DownloadPlayerCard
        show={playerCardDownloadShow}
        handlePlayerDownloadCardClose={handlePlayerDownloadCardClose}
        handleShow={handlePlayerCardShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
        playerSelected={playerSelected}
        playerProfileView={playerProfileView}
        handleGamePassModalShow={handleGamePassModalShow}
        userPaidForClub={userPaidForClub}
        playerSponsor={playerSponsor}
        club_details={club_details}
      />
      <GamePassModal
        showGamePass={showGamePass}
        handleCloseGamePass={handleCloseGamePass}
      />
    </>
  );
};

export default PlayersCard;
